import gql from 'graphql-tag';
import { JobInvoiceableInbox } from './jobInvoiceInbox';
import { JobInvoiceableDeferredInbox } from './jobInvoiceableDeferredInbox';
import { Query } from '../../tickets/components/TicketFacts';

const CreateJobInvoiceMutation = gql`
  mutation CreateJobInvoice($input: JobCreateInvoiceInput!) {
    job_create_invoice(input: $input) {
      id
    }
  }
`;

export const createJobInvoiceApi = async (client, jobId, ticketId) => {
  const variables = {
    input: {
      id: jobId,
    },
  };

  const options = {
    mutation: CreateJobInvoiceMutation,
    variables,
    refetchQueries: [
      { query: JobInvoiceableInbox },
      { query: JobInvoiceableDeferredInbox },
      /* NOTE: By refetching the data for the ticket facts component after a job has been
       * sent to sage, we ensure that the invoice number that was created for the job
       * will be displayed */
      { query: Query, variables: { ticketId } },
    ],
  };

  const result = await client.mutate(options);
  return {
    result,
  };
};
